// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HorizontalStackedNouns_wrapper__2QZh9","nounWrapper":"HorizontalStackedNouns_nounWrapper__1HsPJ"};